import React from 'react';
import styled from 'styled-components';
import LoadingSkeleton from '../../../../shared/components/loading/LoadingSkeleton';

const SegmentedGraphSkeleton = () => (
    <div>
        <UpperWrapper>
            <ItemLoadingSkeleton height="20px" width="20px" circle />
            <ItemLoadingSkeleton height="18px" width="60px" />
            <ItemLoadingSkeleton height="20px" width="20px" circle />
            <ItemLoadingSkeleton height="18px" width="60px" />
        </UpperWrapper>
        <StyledLoadingSkeleton height="340px" />
    </div>
);

const UpperWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
`;

const ItemLoadingSkeleton = styled(LoadingSkeleton)`
    margin-right: 8px;
`;

const StyledLoadingSkeleton = styled(LoadingSkeleton)`
    padding: 10px 40px 40px 40px;
`;

export default SegmentedGraphSkeleton;